// assets/elite-pay.js
// Cálculo compartido de cuotas Elite Pay — usado por credit-simulator.liquid (PDP)
// y por product-card.liquid (grid de colección, mega-menú, recomendaciones,
// recently-viewed, quick-view). Mantener ambos consumidores en sync si se cambia
// la fórmula de amortización.
(function (window) {
  'use strict';

  if (window.ElitePay) return;

  // Marca una card ya procesada para no recalcular en cada mutación del DOM.
  var PROCESSED_ATTR = 'data-elite-pay-done';

  function formatMoney(cents) {
    if (isNaN(cents) || cents < 0) cents = 0;
    var amount = cents / 100;
    // Format as Colombian-friendly: $ X.XXX (non-breaking space so "$" never wraps away from the amount)
    return '$ ' + amount.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function amortizacion(principal, monthlyRate, months) {
    if (monthlyRate <= 0) return { monthly: principal / months, total: principal };
    var r = monthlyRate / 100;
    var factor = Math.pow(1 + r, months);
    var monthly = principal * r * factor / (factor - 1);
    return { monthly: monthly, total: monthly * months };
  }

  function calcPlan(pvpCents, epDiscount, epMonthlyRate, months) {
    epDiscount = epDiscount || 25;
    epMonthlyRate = epMonthlyRate || 2.13;
    var epBase = pvpCents * (1 - epDiscount / 100);
    var plan = amortizacion(epBase, epMonthlyRate, months);
    return {
      epBase: epBase,
      monthly: plan.monthly,
      weekly: plan.monthly / 4,
      total: plan.total
    };
  }

  // Rellena el monto de la cuota SEMANAL en cada card con [data-elite-pay-card].
  // La etiqueta ("12 meses con cuota semanal de") esta en product-card.liquid.
  // `root` puede ser el document, un contenedor, o la propia card. `force` re-procesa
  // aunque ya esté marcada como hecha (por si cambian los data-* dinámicamente).
  function initCardInstallments(root, force) {
    var scope = root || document;
    var selfMatch = scope.nodeType === 1 && scope.matches && scope.matches('[data-elite-pay-card]');
    var nodes = selfMatch ? [scope] : (scope.querySelectorAll ? scope.querySelectorAll('[data-elite-pay-card]') : []);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!force && el.getAttribute(PROCESSED_ATTR) === '1') continue;

      var pvpCents = parseInt(el.getAttribute('data-pvp-cents'), 10) || 0;
      var epDiscount = parseFloat(el.getAttribute('data-ep-discount')) || 25;
      var epMonthlyRate = parseFloat(el.getAttribute('data-ep-monthly-rate')) || 2.13;
      var months = parseInt(el.getAttribute('data-months'), 10) || 12;

      if (pvpCents <= 0) continue;

      var plan = calcPlan(pvpCents, epDiscount, epMonthlyRate, months);
      var target = el.querySelector('[data-elite-pay-weekly]');
      if (target) {
        // Solo el monto: la etiqueta ("12 meses con cuota semanal de") vive en
        // product-card.liquid. Se quito el sufijo " sin interés" porque el plan SI
        // aplica interes (tasa mensual epMonthlyRate, 2.13% por defecto) — el total
        // amortizado supera la base Elite Pay, asi que la frase era falsa.
        target.textContent = formatMoney(plan.weekly);
        el.setAttribute(PROCESSED_ATTR, '1');
      }
    }
  }

  window.ElitePay = {
    formatMoney: formatMoney,
    amortizacion: amortizacion,
    calcPlan: calcPlan,
    initCardInstallments: initCardInstallments
  };

  function initAll() {
    initCardInstallments(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Cobertura universal: cualquier card que se inserte DESPUÉS de la carga
  // inicial — mega-menú del header, "También te puede interesar"
  // (product-recommendations), recently-viewed, quick-view, o cualquier sección
  // futura — se procesa al aparecer en el DOM. Un observador global es más
  // robusto que engancharse a los eventos de cada sección una por una.
  if (typeof MutationObserver === 'function') {
    var pending = false;
    var OBSERVE_OPTS = { childList: true, subtree: true };
    var observer = new MutationObserver(function (mutations) {
      // Solo reaccionar si realmente se agregaron nodos (evita reprocesar en cada
      // cambio de atributo/texto). Se coalesce en un microtask para no correr N
      // veces cuando se inyecta un bloque grande de golpe.
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          if (!pending) {
            pending = true;
            Promise.resolve().then(function () {
              pending = false;
              // Desconectar mientras se procesa: al escribir textContent se
              // reemplaza el nodo de texto (cuenta como addedNodes) y re-armaria
              // el observer innecesariamente. Reconectar al terminar.
              observer.disconnect();
              initCardInstallments(document);
              observer.observe(document.documentElement, OBSERVE_OPTS);
            });
          }
          break;
        }
      }
    });
    observer.observe(document.documentElement, OBSERVE_OPTS);
  }
})(window);
